export const StationEvents = {
    maintenanceStationChannel: (stationId: number) => `maintenance-station.${stationId}`,

    stationConnected: () => 'station:connected',
    stationDisconnected: () => 'station:disconnected',

    chambersStartEdit: () => 'chambers:edit',
    chambersState: () => 'chambers:state',
    chambersSave: () => 'chambers:save',

    chambersSaveAck: () => 'chambers:save-ack',
    chambersSaveNack: () => 'chambers:save-nack',
};
